import { useEffect, useState } from 'react';
import useLockedTheme from './useLockedTheme';
import { getInitialTheme } from '../Services/datesHelper';
import { VERIFY_THEME_TIME } from '../Constants/constant';


/**
 * Automatically locks the theme to either light or dark based on the current time of day.
 * The theme is updated every VERIFY_THEME_TIME milliseconds.
 */
const useAutoThemeLock = () => {
  const [currentTheme, setCurrentTheme] = useState(getInitialTheme());

  useLockedTheme(currentTheme);

  useEffect(() => {
    const interval = setInterval(() => {
      const newTheme = getInitialTheme();
      if (newTheme !== currentTheme) {
        setCurrentTheme(newTheme);
      }
    }, VERIFY_THEME_TIME);

    return () => clearInterval(interval);
  }, [currentTheme]);
};

export default useAutoThemeLock;
